import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";

const PublicLayout = () => {
  return (
    <div>
      <Header />
      <main className="p-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
